export enum LobbyTypeEnum {
	Classic = 'classic',
	TotalWins = 'total-wins',
	Survivor = 'survivor',
	CrowdLock = 'crowd-lock',
	HeadToHead = 'head-to-head',
}
